import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import FormateCurrency from 'utils/FormateCurrency';
export const InfoCard = ({title,value=1000,extra_value,enableColor=false}) => {
 return( 
        <Card  sx={{width:'100%',height:'100%',boxSizing:'border-box', boxShadow:'0px 0px 2px #fff',bgcolor:'primary.light'}} elevation={0}>
            <CardContent style={{padding:15}} sx={{boxSizing:'border-box',paddingBottom:0}}>
                <Typography  fontWeight={800} textAlign='center'  sx={
                    {
                        fontSize:{
                            xs:'15px',
                            sm:"20px",
                            md:'26px',
                            lg:'22px'
                        },
                        fontWeight:'bold',
                        color:enableColor?value>0?'rgb(149, 242, 4)':'red': "common.white",
                    }
                }  color="text.secondary">
                   {FormateCurrency(value)}{extra_value}
                </Typography>
                <Typography marginTop={1} textAlign='center'  sx={
                    {
                        fontSize:{
                            xs:'10px',
                            sm:"14px",
                            md:'14px',
                            lg:'18px'
                        },

                    }
                }   color="common.white">
                  {title}
                </Typography>
            </CardContent>
        </Card>
   
 )
}

export default InfoCard;